import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	ProductRoomAvailabilityResult,
	ProductRoomAvailabilityStateResult,
	ProductRoomSlaveAvailabilityResult,
} from './accommodations.model';
import { InfoboxService } from '@/common/infobox/infobox.service';

@Injectable({
	providedIn: 'root',
})
export class AccommodationsApiService {
	constructor(
		private readonly httpClient: HttpClient,
		private readonly infobox: InfoboxService,
	) {}

	productRoomAvailability(params: string): Observable<ProductRoomAvailabilityResult> {
		return this.httpClient.get(`${environment.apiUrl}/product/room/availability/${params}`);
	}

	productRoomSlaveAvailability(params: string): Observable<ProductRoomSlaveAvailabilityResult> {
		return this.httpClient.get(`${environment.apiUrl}/product/room_slave/availability/${params}`);
	}

	productRoomAvailabilityState(params: string, productsIn: string): Observable<ProductRoomAvailabilityStateResult> {
		return this.httpClient.get(
			`${environment.apiUrl}/product/room/availability_state/${params}&room__product__in=${productsIn}`,
		);
	}
}
